import { Component, OnInit, Input } from '@angular/core';
import { LabMDM } from '../masterdata/models/lab';
import { MessagesService } from '../messages/messages.service';
import { MasterDataService } from '../masterdata/masterdata.service';
import { ErrorHandler } from '../utils/error-handler';
import { Template } from '../masterdata/models/template';
import { MachineType } from '../masterdata/models/machineType';
import { Printer } from '../masterdata/models/printer';
import { CarrierState } from '../masterdata/models/carrierState';
import { MdmProcessStepService } from './mdm-process-step.service';
import { Process } from '../masterdata/models/process';
import { Station } from '../masterdata/models/station';
import { OperetionHistoryDTO } from '../masterdata/models/operationHistory';
import { ProblemCategoryService } from '../mdm-problem-category-template/problem-category-service';
import { SelectItem } from 'primeng/api';

const tagAssignment = 'Tag Assignment';

const amountValidation = 'Amount Validation';
const wellProcessing384 = '384-well processing';
const partialCopy = 'Partial Copy';
const mergeAllowed = 'Merge Allowed';
const adjustSpecialHandling  = "Please adjust the special handling accordingly";
const specialHandling  = "Special Handlings Selection error";
const split384To96 = 'Split 384 to 96';
const tagAssignment96To384 = 'Tag Assignment 96 to 384';
const merge96To384 = 'Merge 96 to 384';
@Component({
  selector: 'app-mdm-process-step',
  templateUrl: './mdm-process-step.component.html',
  styleUrls: ['./mdm-process-step.component.css']
})
export class MdmProcessStepComponent implements OnInit {

  @Input() masterLists: CarrierState[];
  @Input() tableCols: any[];
  @Input() title: string;
  @Input() processStepOptions: SelectItem[];
  @Input() labOptions: LabMDM[];
  @Input() machineTypesOptions: MachineType[];
  @Input() printerOptions: Printer[];
  @Input() templateOptions: Template[];

  isNewMasterList: boolean;
  popupTitle: string;
  masterList: CarrierState;
  displayMasterListDialog: boolean = false;
  errorHandler: ErrorHandler = new ErrorHandler;
  selectedMasterList: any;
  isProcessStepName: string = "name";
  isLab: string = "lab";
  isProcessStepMachineType: string = "machineType";
  isProcessStepPrinter: string = "printer";
  isDefaultTemplate: string = "defaultTemplate";
  isNextStep: string = "nextStep";
  isProcessList: string = "processList";
  isPlatePrefix: string = "platePrefixes"
  isProcess: string = "process";
  isStation: string = "station";
  isActive: string = "active";
  isWorkfileDef: string = "workfileDefinition";
  isSourcePlatePrefixes: string = "sourcePlatePrefixes";
  isStepDisplayName: string = "stepDisplayName";
  isSortingName: string = "sortingName";
  isSpecialHandling: string = "specialHandlerList";
  isqcEvaluationStep: string = "qcEvaluationStepList";
  isQcType: string = "qctype";
  selectedLabName: string;
  selectedLab: LabMDM;
  selectedMachineTypeName: string;
  selectedMachineType: MachineType;
  selectedPrinterName: string;
  selectedPrinter: Printer;
  selectedTemplateName: string;
  selectedTemplate: Template;
  extraField1: string;
  inputCheck1: string;
  extraField2: string;
  inputCheck2: string;
  platePrefixes: string;
  storagePlatePrefix: string;

  sourcePlatePrefixes: string;
  selectedLabId: string;

  selectedProcessStep: any;
  nextProcessStep: any;

  processResults: Process[] = [];
  processOptions: any[] = [];
  qcTypeOptions: any[] = [];
  selectedProcess: any;
  selectedQcType: any;
  processWithTagSystemMap = new Map();
  tagSystemWithPlatesCountMap = new Map();

  stationResults: Station[] = [];
  stationOptions: any[] = [];
  selectedStation: any;

  workfileDefOptions: SelectItem[];
  selectedWorkfileDef: string[];
  selectedSpecialHandlers: string[];
  worfileDefMap = new Map<string, any[]>();
  puid = localStorage.getItem('PUID');
  specialHandlingOptions: any[];
  tagSystemActive: any[] = [];
  selectedQCEvaluationStep: string[];
  problemCategoryOptions: any[] = []
  selectedProblemCategoryForQCPassed: string;
  selectedProblemCategoryForQCFailed: string
  blocked = false

  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService,
    private _msdmProcessStepService: MdmProcessStepService, private _problemCategoryService: ProblemCategoryService) { }

  ngOnInit() {
    this.popupTitle = this.title;
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.specialHandlingOptions = [

      { label: wellProcessing384, value: wellProcessing384 },
      { label: amountValidation, value: amountValidation },
      { label: 'AmpliconTarget', value: 'AmpliconTarget' },
      { label: 'EQC plate volume plus FLX', value: 'EQC plate volume plus FLX' },
      { label: 'EQC dilution for FA', value: 'EQC dilution for FA' },
      { label: 'EQC evaluation', value: 'EQC evaluation' },
      { label: 'EQC SampleDil and Evaluation', value: 'EQC SampleDil and Evaluation' },
      { label: 'EQC tubes volume plus FA', value: 'EQC tubes volume plus FA' },
      { label: 'EQC tubes volume plus FLX', value: 'EQC tubes volume plus FLX' },
      { label: 'EQC tubes volume plus UV', value: 'EQC tubes volume plus UV' },
      { label: 'EQC UV to FA', value: 'EQC UV to FA' },
      { label: 'EQC UV to FLX', value: 'EQC UV to FLX' },
      { label: 'FA Ladder', value: 'FA Ladder' },
      { label: merge96To384, value: merge96To384 },
      { label: mergeAllowed, value: mergeAllowed },
      { label: 'manualPooling', value: 'manualPooling' },
      { label: 'manualTagAssignment', value: 'manualTagAssignment' },
      { label: partialCopy, value: partialCopy },
      { label: 'preHybPooling', value: 'preHybPooling' },
      { label: 'preSeqPooling', value: 'preSeqPooling' },
      { label: split384To96, value: split384To96 },
      { label: tagAssignment, value: tagAssignment },
      { label: tagAssignment96To384, value: tagAssignment96To384 },
      { label: "qPCR LibQC", value: "qPCR LibQC" },
    ];
    this.qcTypeOptions = [{ label: 'entryQC', value: 'entryQC' },
    { label: 'finalLibQC', value: 'finalLibQC' },
    { label: 'preHybLibQC', value: 'preHybLibQC' },
    { label: 'libQc1', value: 'libQc1' },
    { label: 'libQc2', value: 'libQc2' }];
  }
  //gets the workfile definition names
  getListOfWorkfileDefinition() {
    this.workfileDefOptions = [];
    this.selectedWorkfileDef = [];
    this.worfileDefMap = new Map();
    this.masterList.stepDisplayName = this.masterList.stepDisplayName ? this.masterList.stepDisplayName : "";
    this._masterDataService.getWorkfileActive(this.selectedLabId, this.masterList.stepDisplayName).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.worfileDefMap = results.data && results.data.workfileMap ? new Map(Object.entries(results.data.workfileMap)) : null;
        if (this.checkForWorkfileDefn()) {
          this.worfileDefMap.get(this.masterList.stepDisplayName).forEach(type => {
            if (type) {
              this.workfileDefOptions.push({ label: type, value: type });
            }
          })
        }
        this.selectedWorkfileDef = this.masterList && this.masterList.workfileDefinition ? this.masterList.workfileDefinition : null;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  checkForWorkfileDefn() {
    return this.worfileDefMap && this.masterList && this.masterList.stepDisplayName && this.worfileDefMap.get(this.masterList.stepDisplayName) && this.selectedProcessStep;
  }

  //Display master Dialog upon clicked on a row
  onRowSelect(event) {
    this.isNewMasterList = false;
    this.masterList = this.cloneMasterList(event.data);
    this.displayMasterListDialog = true;
    this.selectedProcessStep = this.masterList.name;
    this.nextProcessStep = this.masterList.nextStep;
    this.storagePlatePrefix = this.masterList.storagePlatePrefix
    this.getActiveOptionsForDropdowns();
    this.getListOfWorkfileDefinition();
    this.platePrefixes = this.masterList.platePrefixes && this.masterList.platePrefixes.join(",");
    this.sourcePlatePrefixes = this.masterList.sourcePlatePrefixes && this.masterList.sourcePlatePrefixes.join(",");
    this.selectedSpecialHandlers = this.masterList.specialHandlerList ? this.masterList.specialHandlerList : null;
    this.selectedQCEvaluationStep = this.masterList.qcEvaluationStepList ? this.masterList.qcEvaluationStepList : null;
    this.selectedQcType = this.masterList.qctype ? this.masterList.qctype : null;
  }

  //Retrieve the Active lab for dropdown
  getActiveOptionsForDropdowns() {
    //Get Active Labs for Lab Drop down
    this._masterDataService.getLabs(true).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.labOptions = results.data;
        this.labOptions.forEach(lab => {
          if (this.masterList && this.masterList.lab && lab._id == this.masterList.lab._id) {
            this.selectedLabName = this.masterList.lab.name;
            this.selectedLab = lab;
          }
        })
        if (!this.masterList || !this.masterList.lab || this.selectedLabName != this.masterList.lab.name)
          this.selectedLab = null;

        //Get the Lab details inside asynchornus call
        // and get drop down details for seleceted lab
        this.getDropDetailsBySelectedLab();
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );

    //Get the next Step from Master List
    if (this.masterList.nextStep) {
      this.nextProcessStep = this.masterList.nextStep;
    }
    else {
      this.nextProcessStep = null;
    }
  }




  //Get Dropdown data by the selected Lab
  getDropDetailsBySelectedLab() {
    this.machineTypesOptions = [];
    this.printerOptions = [];
    this.templateOptions = [];

    if (this.selectedLab) {
      //Get Active Machine Types for Machine Type Drop down
      this._msdmProcessStepService.getMachineTypesByLab(this.selectedLab, true).subscribe(
        results => {
          if (!results) {
            return;
          }
          this.machineTypesOptions = results.data;
          this.machineTypesOptions.forEach(type => {
            if (this.masterList && this.masterList.machineType && type._id == this.masterList.machineType._id) {
              this.selectedMachineTypeName = this.masterList.machineType.name;
              this.selectedMachineType = type;
            }
          })
          if (!this.masterList || !this.masterList.machineType || this.selectedMachineTypeName != this.masterList.machineType.name)
            this.selectedMachineType = null;
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
        }
      );

      //Get Active Printers for Printer Drop down
      this._msdmProcessStepService.getPrintersByLab(this.selectedLab, true).subscribe(
        results => {
          if (!results) {
            return;
          }
          this.printerOptions = results.data;
          this.printerOptions.forEach(printer => {
            if (this.masterList && this.masterList.printer && printer._id == this.masterList.printer._id) {
              this.selectedPrinterName = this.masterList.printer.name;
              this.selectedPrinter = printer;
            }
          })
          if (!this.masterList || !this.masterList.printer || this.selectedPrinterName != this.masterList.printer.name)
            this.selectedPrinter = null;
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
        }
      );

      //Get Active Templates for Template Drop down
      this._msdmProcessStepService.getTemplatesByLab(this.selectedLab, true).subscribe(
        results => {
          if (!results) {
            return;
          }
          this.templateOptions = results.data;
          this.templateOptions.forEach(template => {
            if (this.masterList && this.masterList.defaultTemplate && template.templateName == this.masterList.defaultTemplate.templateName) {
              this.selectedTemplateName = this.masterList.defaultTemplate.templateName;
              this.selectedTemplate = template;
            }
          })
          if (!this.masterList || !this.masterList.defaultTemplate || this.selectedTemplateName != this.masterList.defaultTemplate.templateName)
            this.selectedTemplate = null;
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
        }
      );

      //get active Process for drop down
      this.getActiveProcessValue();

      //get active station for drop down
      this._masterDataService.getStationData(this.selectedLab._id).subscribe(
        results => {
          if (!results.data) {
            return;
          }
          this.stationOptions = [];
          this.stationResults = results.data;
          this.stationResults.forEach(station => {
            if (station.active) {
              this.stationOptions.push({ label: station.name, name: station.name });
            }
            if (this.masterList && this.masterList.station == station.name) {
              var selectedType = { label: station.name, name: station.name };
              this.selectedStation = selectedType;
            }
          })
          if (!this.masterList || !this.masterList.station)
            this.selectedStation = null;
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
        }
      );
      this.getActiveProblemCategories()

    }
  }
  getActiveProblemCategories() {
    this.problemCategoryOptions = []
    this.selectedProblemCategoryForQCFailed = null;
    this.selectedProblemCategoryForQCPassed = null;
    this._problemCategoryService.getProblemsListWithFilter(this.selectedLabId, true).subscribe(
      result => {
        if (result.data && result.data.length > 0) {
          result.data.forEach(category => {
            this.problemCategoryOptions.push({ label: category.categoryName, value: category.categoryName })
          })
          this.problemCategoryOptions.forEach(category => {
            if (this.masterList && this.masterList.problemCategoryForQCPassed == category.value) {
              this.selectedProblemCategoryForQCPassed = category.value
            }
            if (this.masterList && this.masterList.problemCategoryForQCFailed == category.value) {
              this.selectedProblemCategoryForQCFailed = category.value
            }
          })
        }
      }, error => {
        this.handleError(error)
      }
    )
  }
  getActiveProcessValue() {
    this._masterDataService.getProcessData(this.selectedLab._id).subscribe(
      results => {
        if (!results.data) {
          return;
        }
        this.processOptions = [];
        this.processWithTagSystemMap = new Map();
        this.processResults = results.data;
        this.processResults.forEach(process => {
          if (process.active) {
            this.processOptions.push({ label: process.name, name: process.name });
            if (process.tagSystemName) {
              this.processWithTagSystemMap.set(process.name, process.tagSystemName);
            }
          }
          if (this.masterList && this.masterList.process == process.name) {
            var selectedType = { label: process.name, name: process.name };
            this.selectedProcess = selectedType;
          }
        });
        if (!this.masterList || !this.masterList.process) {
          this.selectedProcess = null;
        }
        this._masterDataService.getMapCountOfActiveTagSystem(this.selectedLabId).subscribe(
          results => {
            if (!results.data.data) {
              return;
            }
            this.tagSystemWithPlatesCountMap = new Map(Object.entries(results.data.data));
          });
        this.tagSystemActive = [];
        this._masterDataService.getTagActiveSystem(this.selectedLab, true).subscribe(
          results => {
            if (!results) {
              return;
            }
            results.data.forEach(tag => {
              this.tagSystemActive.push(tag.tagSystemName);
            });
          });
      },
      error => {
        this.handleError(error);
      });
  }

  handleError(error: any) {
    let message = this.errorHandler.handleError(error);
    this._messageService.addErrorMessage(message);
  }
  //Display Add Dialog upon clicking Add button
  showDialogToAddMasterList() {
    this.isNewMasterList = true;
    this.masterList = new CarrierState();
    this.displayMasterListDialog = true;
    this.selectedLab = null;
    this.getActiveOptionsForDropdowns();
    this.selectedProcessStep = null;
    this.platePrefixes = null;
    this.sourcePlatePrefixes = null;
    this.workfileDefOptions = [];
    this.selectedWorkfileDef = null;
    this.selectedProcess = null;
    this.selectedStation = null;
    this.selectedSpecialHandlers = [];
    this.selectedQCEvaluationStep = [];
    this.selectedProblemCategoryForQCFailed = null;
    this.selectedProblemCategoryForQCPassed = null;
    this.selectedQcType = null;
  }

  cloneMasterList(list: any): any {
    let masterList = {};
    for (let prop in list) {
      masterList[prop] = list[prop];
    }
    return masterList;
  }

  validateSpecialHandling() {
    let specialHandlerMap = {}
    let eqcCount = this.getEqcCount(specialHandlerMap)
    if (eqcCount > 1) {
      this._messageService.addErrorMessage({ severity: 'error', summary: specialHandling, detail: "different EQC Special Handlings can't be combined for one Process Step" });
      return false;
    }
    if (this.validateEQCWithAmountValidationAndTagAssignment(eqcCount, specialHandlerMap)) {
      this._messageService.addErrorMessage({ severity: 'error', summary: specialHandling, detail: `BB NGS does not support concurrent selection of any EQC special handling with special handling other than FA_Ladder, Merge Allowed & AmpliconTarget` });
      return false;
    }

    if (specialHandlerMap['preSeqPooling'] && (specialHandlerMap[amountValidation] || specialHandlerMap[tagAssignment])) {
      this._messageService.addErrorMessage({ severity: 'error', summary: specialHandling, detail: `BB NGS does not support the concurrent selection of special handling "preSeqPooling" and any EQC special handling, Amount Validation and Tag Assignment. ${adjustSpecialHandling}.` });
      return false;
    }
    if (specialHandlerMap['preHybPooling'] && ( specialHandlerMap[partialCopy] || specialHandlerMap['preSeqPooling'] || specialHandlerMap[amountValidation] || specialHandlerMap[tagAssignment])) {
      this._messageService.addErrorMessage({ severity: 'error', summary: specialHandling, detail: `BB NGS does not support the concurrent selection of special handling "preHybPooling" and any EQC special handling, Amount Validation, Partial Copy, Preseq Pooling and Tag Assignment. ${adjustSpecialHandling}.` });
      return false;
    }
    if (specialHandlerMap[partialCopy] && (specialHandlerMap['preSeqPooling'] || specialHandlerMap[amountValidation] || specialHandlerMap[mergeAllowed] || specialHandlerMap[tagAssignment])) {
      this._messageService.addErrorMessage({ severity: 'error', summary: specialHandling, detail: `BB NGS does not support the concurrent selection of special handling "Partial Copy" and any EQC special handling, Amount Validation, Merge Allowed, Preseq Pooling and Tag Assignment. ${adjustSpecialHandling}.` });
      return false;
    }
    return this.validateManualPoolingAndTagAsssignment(specialHandlerMap, eqcCount);
  }
  private validateEQCWithAmountValidationAndTagAssignment(eqcCount: number, specialHandlerMap: {}) {
    const specialHandlingsAllowedWithEQC = ['FA Ladder', mergeAllowed, 'AmpliconTarget']
    let invalidSpecialHandling = false
    if(eqcCount === 1) {
      Object.keys(specialHandlerMap).forEach(specialHandling =>{
        if(!specialHandlingsAllowedWithEQC.includes(specialHandling)) {
          invalidSpecialHandling = true
        }
      })
    }
    return invalidSpecialHandling
  }

  validateManualPoolingAndTagAsssignment(specialHandlerMap: any, eqcCount: number): boolean {
    if (specialHandlerMap['manualTagAssignment'] && (specialHandlerMap['preHybPooling'] || specialHandlerMap['preSeqPooling'] || specialHandlerMap[amountValidation] || specialHandlerMap[tagAssignment] || specialHandlerMap[partialCopy] || specialHandlerMap['manualPooling'])) {
      this._messageService.addErrorMessage({ severity: 'error', summary: specialHandling, detail: `BB NGS does not support the concurrent selection of special handling "manualTagAssignment" and any EQC special handling, Amount Validation, manualPooling, Partial Copy, Preseq Pooling, PreHyb Pooling and Tag Assignment. ${adjustSpecialHandling}.` });
      return false;
    }
    if (specialHandlerMap['manualPooling'] && (specialHandlerMap['preHybPooling'] || specialHandlerMap['preSeqPooling'] || specialHandlerMap[amountValidation] || specialHandlerMap[tagAssignment] || specialHandlerMap[partialCopy] || specialHandlerMap['AmpliconTarget'])) {
      this._messageService.addErrorMessage({ severity: 'error', summary: specialHandling, detail: `BB NGS does not support the concurrent selection of special handling "manualPooling" and any EQC special handling, Amount Validation, AmpliconTarget, Partial Copy, Preseq Pooling, PreHyb Pooling and Tag Assignment. ${adjustSpecialHandling}.` });
      return false;
    }
    return true;
  }

  getEqcCount(specialHandlerMap: any): number {
    let eqcCount = 0;
    this.selectedSpecialHandlers.forEach(specialHandle => {
      if (specialHandle.startsWith("EQC"))
        eqcCount += 1;
      else {
        specialHandlerMap[specialHandle] = true;
      }
    }
    )
    return eqcCount
  }
  //Insert or update Template
  saveMasterList() {
    if (!this.validateSpecialHandling()) {
      return;
    }

    let masterLists = [...this.masterLists];
    this.masterList.name = this.selectedProcessStep;
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
    this.masterList.machineType = new MachineType();
    this.masterList.machineType = this.selectedMachineType;
    this.masterList.printer = new Printer();
    this.masterList.printer = this.selectedPrinter;
    this.masterList.defaultTemplate = new Template();
    this.masterList.defaultTemplate = this.selectedTemplate;
    this.masterList.qctype = this.selectedQcType;
    this.masterList.storagePlatePrefix = this.storagePlatePrefix;
    this.nextStepFuntionCheck();

    if (this.checkForSourcePlate()) {
      if (this.regexCheckForSourcePlate()) {
        this._messageService.addErrorMessage({
          severity: 'error', summary: 'Invalid Source Plate Prefixes Pattern!',
          detail: 'Source Plate Prefixes must contain only 0-9,a-z,A-Z,underscore'
        });
        return;
      }
      this.masterList.sourcePlatePrefixes = this.sourcePlatePrefixes.split(",");
    }
    else {
      this.masterList.sourcePlatePrefixes = [];
    }
    if (this.platePrefixesCheck()) {
      if (this.platePrefixesRegexCheck()) {
        this._messageService.addErrorMessage({
          severity: 'error', summary: 'Invalid Target Plate Prefixes Pattern!',
          detail: 'Target Plate Prefixes must be comma separated containing only 0-9,a-z,A-Z,underscore'
        });
        return;
      }
      this.masterList.platePrefixes = this.platePrefixes.replace(/,\s*$/, "").split(",");
    } else {
      this.masterList.platePrefixes = [];
    }
    this.setWorkfileDefToSave();
    this.masterList.specialHandlerList = this.selectedSpecialHandlers;
    this.masterList.qcEvaluationStepList = this.selectedQCEvaluationStep;

    let stepDisplayFlag = false;
    let sortingNameFlag = false;
    this.masterLists.forEach(carrier => {
      ({ stepDisplayFlag, sortingNameFlag } = this.checkForDuplicate(carrier, stepDisplayFlag, sortingNameFlag));
    });
    if (this.duplicateCheckbothstepSortName(stepDisplayFlag, sortingNameFlag)) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Duplicate Step Display Name and Sorting Name!',
        detail: 'Step Display Name and Sorting Name are both already present.'
      });
      return;
    } else if (this.duplicateForStepSortName(stepDisplayFlag, sortingNameFlag)) {
      return this.stepDisplayNameDuplicate(stepDisplayFlag);
    }
    if (this.selectedSpecialHandlers.includes(tagAssignment) && !this.checkForActiveTagSystemAndTagPlatesForTagAssignment()) {
      return;
    }
    if (this.checkForNextStepQCPassedAndProblemCategory()) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Error on Saving Process step definition',
        detail: "Problem Category for QC passed must be selected, when Next Step for QC passed is selected."
      });
      return;
    }
    if (this.checkForNextStepQCFailedAndProblemCategory()) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Error on Saving Process step definition',
        detail: "Problem Category for QC failed must be selected, when Next Step for QC failed is selected."
      });
      return;
    }
    this.appendHistory("Process Type");
    this.funtionForSaveUpdate(masterLists);
  }
  getCommaSeperatedSpecialHandlerOtherThanhandler(spHandler) {
    let specialHandlers = []
    if (spHandler === partialCopy) {
      specialHandlers = this.selectedSpecialHandlers.filter(handler => ![spHandler, 'FA Ladder', 'AmpliconTarget'].includes(handler))

    } else if(spHandler === 'manualPooling') {
      specialHandlers = this.selectedSpecialHandlers.filter(handler => ![spHandler, 'FA Ladder', mergeAllowed].includes(handler))
    } else {
      specialHandlers = this.selectedSpecialHandlers.filter(handler => ![spHandler, 'FA Ladder', mergeAllowed, 'AmpliconTarget'].includes(handler))
    }
    return specialHandlers.join(",\t");
  }


  private checkForNextStepQCFailedAndProblemCategory() {
    return this.masterList.nextStepForQCFailed && this.masterList.nextStepForQCFailed.length > 0 && !this.masterList.problemCategoryForQCFailed;
  }

  private checkForNextStepQCPassedAndProblemCategory() {
    return this.masterList.nextStepForQCPassed && this.masterList.nextStepForQCPassed.length > 0 && !this.masterList.problemCategoryForQCPassed;
  }

  private checkForActiveTagSystemAndTagPlatesForTagAssignment() {
    if (this.checkProcessWithTagSystem()) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Error on Saving Process step definition',
        detail: "Special handling Tag Assignment is not allowed with current process, because this process doesn't have an (active) tag system definition."
      });
      return false;
    } else if (!this.tagSystemWithPlatesCountMap.has(this.processWithTagSystemMap.get(this.selectedProcess.name))) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Error on Saving Process step definition',
        detail: "Special handling Tag Assignment is not allowed with current process, because the tag system of this process doesn't have an (active) tag plate definition."
      });
      return false;
    }
    return true
  }
  stepDisplayNameDuplicate(stepDisplayFlag: boolean) {
    let message = stepDisplayFlag ? ' Step Display Name' : ' Sorting Name';
    return this._messageService.addErrorMessage({
      severity: 'error', summary: 'Duplicate' + message + '!',
      detail: message + ' already present'
    });
  }

  platePrefixesRegexCheck() {
    return !this.regexMatcher("^[a-zA-Z0-9_,]*$", this.platePrefixes);
  }

  checkProcessWithTagSystem() {
    return !this.processWithTagSystemMap.has(this.selectedProcess.name) || !this.tagSystemActive.includes(this.processWithTagSystemMap.get(this.selectedProcess.name));
  }

  nextStepFuntionCheck() {
    if (this.nextProcessStep) {
      this.masterList.nextStep = this.nextProcessStep;
    }
    else {
      this.masterList.nextStep = null;
    }
    this.masterList.process = this.selectedProcess.name;
    this.masterList.station = this.selectedStation.name;
  }

  setWorkfileDefToSave() {
    if (this.workfileDefOptions.length == 0) {
      this.masterList.workfileDefinition = [];
    } else {
      this.masterList.workfileDefinition = this.selectedWorkfileDef;
    }

  }

  duplicateForStepSortName(stepDisplayFlag: boolean, sortingNameFlag: boolean) {
    return stepDisplayFlag || sortingNameFlag;
  }

  duplicateCheckbothstepSortName(stepDisplayFlag: boolean, sortingNameFlag: boolean) {
    return stepDisplayFlag && sortingNameFlag;
  }

  checkForSourcePlate() {
    return this.sourcePlatePrefixes && this.sourcePlatePrefixes.trim();
  }
  platePrefixesCheck() {
    return this.platePrefixes && this.platePrefixes.trim();
  }

  regexCheckForSourcePlate() {
    return !this.regexMatcher("^[a-zA-Z0-9_]*$", this.sourcePlatePrefixes);
  }

  funtionForSaveUpdate(masterLists: CarrierState[]) {
    if (this.isNewMasterList) {
      this.saveMasterData(masterLists);
    } else {
      this.updateMasterData(masterLists);
    }
  }

  checkForDuplicate(carrier: CarrierState, stepDisplayFlag: boolean, sortingNameFlag: boolean) {
    if (carrier._id && carrier._id != this.masterList['_id'] && this.masterList['stepDisplayName'] && carrier.stepDisplayName && carrier.stepDisplayName.trim().toLowerCase() === this.masterList['stepDisplayName'].trim().toLowerCase()) {
      stepDisplayFlag = true;
    }
    if (carrier._id && carrier._id != this.masterList['_id'] && this.masterList['sortingName'] && carrier.sortingName && carrier.sortingName.trim().toLowerCase() === this.masterList['sortingName'].trim().toLowerCase()) {
      sortingNameFlag = true;
    }
    return { stepDisplayFlag, sortingNameFlag };
  }

  regexMatcher(regex: string, constSubstring: string): boolean {
    let regexp = new RegExp(regex);
    return regexp.test(constSubstring);
  }

  saveMasterData(masterLists: CarrierState[]) {
    let eqcCount = this.validateAmountAndTagAssignment();

    if (eqcCount) {
      return this._messageService.addErrorMessage({
        severity: 'error', summary: 'Validation Failure',
        detail: `BB NGS does not support the concurrent selection of special handling "Available Amount" and "Tag Assignment". ${adjustSpecialHandling}`
      });
    } else {
      this.blocked = true
      this._masterDataService.addCarrierState(this.masterList).subscribe(
        results => {
          if (!results) {
            return;
          }
          this.blocked = false
          masterLists = [...this.masterLists];
          masterLists.push(results.data);
          this.masterLists = masterLists;
          this.masterList = null;
          this.displayMasterListDialog = false;
        },
        error => {
          this.blocked = false
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
          this.displayMasterListDialog = true;
        }
      );
    }
  }

  //Updates a Template in DB
  updateMasterData(masterLists: CarrierState[]) {
    let eqcCount = this.validateAmountAndTagAssignment();

    if (eqcCount) {
      return this._messageService.addErrorMessage({
        severity: 'error', summary: 'Validation Failure',
        detail: `BB NGS does not support the concurrent selection of special handling "Available Amount" and "Tag Assignment". ${adjustSpecialHandling}`
      });
    } else {
      this.blocked = true
      this._masterDataService.updateCarrierState(this.masterList).subscribe(
        results => {
          if (!results) {
            return;
          }
          this.blocked = false
          masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
          this.masterLists = masterLists;
          this.masterList = null;
          this.displayMasterListDialog = false;
        },
        error => {
          this.blocked = false
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
          this.displayMasterListDialog = true;
        }
      );

    }
  }

  private validateAmountAndTagAssignment() {
    let eqcCount = 0;
    this.selectedSpecialHandlers.forEach(specialHandle => {
      if (specialHandle == "Amount Validation" || specialHandle == "Tag Assignment")
        eqcCount += 1;
    });
    return eqcCount == 2;
  }

  //Check if the Template Name or Lab is Entered or not, if not disable Save button
  isSaveDisabled() {
    if (this.masterList == undefined || this.masterList == null)
      return true;
    if (!this.selectedLab || !this.selectedProcessStep || !this.selectedPrinter
      || !this.selectedProcess || !this.selectedStation || !this.masterList["stepDisplayName"] || !this.masterList["sortingName"])
      return true;
    return false;
  }

  //Disable the field depending on Extra Field1
  isInputCheck1Disabled() {
    if (this.extraField1 && this.extraField1.trim() != "") {
      return false;
    }
    else {
      this.inputCheck1 = null;
      return true;
    }
  }

  //Disable the field depending on Extra Field2
  isInputCheck2Disabled() {
    if (this.extraField2 && this.extraField2.trim() != "") {
      return false;
    }
    else {
      this.inputCheck2 = null;
      return true;
    }
  }
  appendHistory(tabName: string) {
    let historyObj: OperetionHistoryDTO = new OperetionHistoryDTO();
    historyObj.puid = this.puid;
    historyObj.operationDateTime = new Date();
    historyObj.tabName = tabName;
    if (this.masterList.history) {
      this.masterList.history.push(historyObj);
    } else {
      this.masterList.history = [];
      this.masterList.history.push(historyObj);
    }
  }
}
